import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "hero-subsection",
  "aria-labelledby": "contact-hero-title"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "hero-shell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-content" }, [
    /*#__PURE__*/_createElementVNode("h1", {
      id: "contact-hero-title",
      class: "hero-title"
    }, "Contactez-nous"),
    /*#__PURE__*/_createElementVNode("p", { class: "hero-description" }, " Notre équipe est là pour répondre à toutes vos questions. N'hésitez pas à nous contacter ! ")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}